import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetUserContentRequestBody,
  IApiGetUserContentResponseBody,
  IApiNotifyUserContentRequestBody,
  IApiNotifyUserContentResponseBody,
  IApiReviewUserContentRequestBody,
  IApiReviewUserContentResponseBody,
} from './UserContentApi.types';

export class UserContentApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    params?: IApiGetUserContentRequestBody,
  ): Promise<IApiGetUserContentResponseBody> {
    const request: IApiJsonRequest = {
      path: '/userGeneratedContents',
      method: 'get',
      params: {
        raw: false,
        reportsCount: true,
        moderator: true,
        ...params,
      },
    };

    const response =
      await this.client.fetchJson<IApiGetUserContentResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async review(
    appId: string,
    contentId: string,
    body: IApiReviewUserContentRequestBody,
  ): Promise<IApiReviewUserContentResponseBody> {
    const request: IApiJsonRequest = {
      path: `/userGeneratedContents/${contentId}/review`,
      method: 'patch',
      body,
    };

    const response =
      await this.client.fetchJson<IApiReviewUserContentResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async notify(
    appId: string,
    contentId: string,
    body: IApiNotifyUserContentRequestBody,
  ): Promise<IApiNotifyUserContentResponseBody> {
    const request: IApiJsonRequest = {
      path: `/userGeneratedContents/${contentId}/notify`,
      method: 'patch',
      body,
    };

    const response =
      await this.client.fetchJson<IApiNotifyUserContentResponseBody>(request, {
        appId,
      });

    return response.body;
  }
}
